import React from "react";
import FormLayout from "./FormLayout";
import logo from "../../assets/Image/logo.png";
import backgroundImage from "../../assets/img/Frame 812.png";
import AccountCreate from "./WithUi/AccountCreate";

function SignUp() {
  return (
    <FormLayout logoSrc={logo} backgroundImageSrc={backgroundImage} T>
      <AccountCreate />
    </FormLayout>
  );
}
export default SignUp;
